import React from "react";
import PropTypes from "prop-types";

import { assertNonEmptyString } from "../../internal/contracts";
import { useThemeA } from "../../internal/ThemeAContext";

const SIZE_CLASSES = {
  attachment: "akv:h-20 akv:w-28",
  badge: "akv:h-14 akv:w-14",
  card: "akv:h-28 akv:w-full",
  fill: "akv:h-full akv:w-full",
  hero: "akv:max-h-[28rem] akv:w-full",
  message: "akv:max-h-48 akv:max-w-full",
  preview: "akv:mx-auto akv:max-h-64 akv:max-w-full",
  viewport: "akv:max-h-[60vh] akv:w-full",
  wide: "akv:aspect-[16/7] akv:w-full",
};

const FIT_CLASSES = {
  contain: "akv:object-contain",
  cover: "akv:object-cover",
};

const SHAPE_CLASSES = {
  control: "akv:rounded-ak-control",
  none: "",
  surface: "akv:rounded-ak-surface",
};

export default function MediaImage({
  alt = "",
  fit = "cover",
  hoverZoom = false,
  loading = "lazy",
  muted = false,
  onError,
  shape = "none",
  size = "fill",
  src,
}) {
  useThemeA("MediaImage");
  assertNonEmptyString("MediaImage", "src", src);

  return (
    <img
      alt={alt}
      className={`akv:block ${SIZE_CLASSES[size]} ${FIT_CLASSES[fit]} ${SHAPE_CLASSES[shape]} ${muted ? "akv:grayscale akv:opacity-35" : ""} ${hoverZoom ? "akv:transition-transform akv:duration-200 akv:group-hover:scale-[1.02] akv:motion-reduce:transform-none akv:motion-reduce:transition-none" : ""}`}
      data-ak-v2-component="media-image"
      loading={loading}
      onError={onError}
      src={src}
    />
  );
}

MediaImage.propTypes = {
  alt: PropTypes.string,
  fit: PropTypes.oneOf(Object.keys(FIT_CLASSES)),
  hoverZoom: PropTypes.bool,
  loading: PropTypes.oneOf(["eager", "lazy"]),
  muted: PropTypes.bool,
  onError: PropTypes.func,
  shape: PropTypes.oneOf(Object.keys(SHAPE_CLASSES)),
  size: PropTypes.oneOf(Object.keys(SIZE_CLASSES)),
  src: PropTypes.string.isRequired,
};
